/*
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2023-09-25 09:35:07
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2024-01-13 15:25:01
 * @FilePath: \xm-runing-main\src\layouts\data\extendList.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default [
  '/ngsUserMainPage',
  '/ngsUnitAdmin',
  '/dashboard/analysis',
  '/unitAdminPageShow',
  '/xm-runing-extend/userMg',
  '/xm-ngs/busConfig/mainProduct/**',
  '/xm-ngs/busConfig/busProConfig/**',
  '/xm-ngs/busConfig/emissionConfig/**',
  '/xm-ngs/busConfig/emissionSource/**',
  '/xm-ngs/monitor-facility/**',
  '/xm-ngs/busConfig/busTempMg/**',
  '/xm-ngs/busConfig/systemParameter/**',
  '/xm-ngs/configuration-center/emission-configuration-process',
  '/xm-ngs/dataAndReport/accountingMgMore/**',
  '/xm-ngs/data-assets/detail/**'
];
